const shopnow = {
  "showNow.title": "ช้อปเลย",
  "showNow.physical.details": "ค้นหาร้านค้าใกล้คุณ",
  "buttonText.findStores": "ค้นหาร้านค้า",
}

const download_now = {
  "download_now.title": "สมาชิกใหม่รับส่วนลด 500 บาท",
  "download_now.p": "สมัคร MyACUVUE® รับสิทธิพิเศษเลย!",
  "download_now.button": "เรียนรู้เพิ่มเติม",
}



const app_promo = {
  "app_promo.block_title": "<span>รับสิทธิพิเศษมากมาย</span> <span><em>ที่แอป</em></span> <span>MyACUVUE® </span>",
  "app_promo.li_01": "รับส่วนลดสุดพิเศษ",
  "app_promo.li_02": "รับคะแนนสะสมทุกการสั่งซื้อ",
  "app_promo.li_03": "แลกคะแนนรับสิทธิพิเศษเฉพาะคุณ",
  "app_promo.cta_title": "สมาชิกใหม่รับส่วนลด 500 บาท",
  "app_promo.cta_btn": "<a>เรียนรู้เพิ่มเติม</a>",
  "app_promo.cta_link": "https://www.acuvue.co.th/acuvuemember"
}

export default {
...shopnow,
...download_now,
...app_promo,
};

